"use strict";
/**
 * Raw JSON WebSocket messages that make up the MHub protocol.
 *
 * Note: the protocol is not completely stable yet, but care is taken to try to
 * support both an older and newer version of the protocol for each version of
 * the server, to ensure smoother upgrades.
 * Most notably, adding a version identifier to the protocol is on the TODO...
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determine whether given object (typically a message) has a sequence number.
 * (Note: this is very different from `if (msg.seq) ...` if the sequence number
 * happens to be zero...)
 * @param msg Anything, but typically a message object with/without sequence number
 * @return true if argument is an object, and contains a numberic `seq` property
 */
function hasSequenceNumber(msg) {
    return typeof msg === "object" && typeof msg.seq === "number";
}
exports.hasSequenceNumber = hasSequenceNumber;
//# sourceMappingURL=protocol.js.map